import { l as layout } from './layout-98a901d5.js';

/**
 *  This whole thing is to support styled-system
 *
 *  Reference: https://styled-system.com/theme-specification
 *
 * */
var breakpoints = [
    layout.breakpoints.xxs,
    layout.breakpoints.xs,
    layout.breakpoints.sm,
    layout.breakpoints.md,
    layout.breakpoints.lg,
    layout.breakpoints.xl,
];
breakpoints.xxs = breakpoints[0];
breakpoints.xs = breakpoints[1];
breakpoints.sm = breakpoints[2];
breakpoints.md = breakpoints[3];
breakpoints.lg = breakpoints[4];
breakpoints.xl = breakpoints[5];
var fontWeights = [400, 600, "bold"];
fontWeights.semibold = 600;
var styledSystem = { breakpoints: breakpoints, fontWeights: fontWeights, space: [], fontSizes: [] };

export { styledSystem as s };
//# sourceMappingURL=styled-system-65150b6c.js.map
